export default function (...args)
{
	return {
		regex: /^\+?(55)(1[1-9]|2[1247]|3[1234578]|4[1-9]|5[1345]|6[1-9]|7[134579]|8[1-9]|9[1-9])([2-9]\d{3,4})(\d{4})$/,
		filter: /[\(\)\-\s.]/g,
		store_mask: '$1$2$3$4',
		display_mask: '+$1 ($2) $3-$4'
	};
}

